import React, {useEffect} from "react";
import cx from 'classnames';
import { SpreadsheetTableDefaultDataItem } from "../../table.types";
import { Row } from "./components/row";
// import { Waypoint } from 'react-waypoint';
import { FixedSizeList } from 'react-window';
import { BodyProps, useController } from "./body.controller";
import { getScrollbarWidth } from "@common/utils/scroll";

import './body.styles.scss';

export const Body: React.FC<BodyProps> = (props) => {
  const { className, data, columns, columnsWidth, onLoadData, pageSize, selectionState, rowSelectionState, onCellMouseDown, onCellMouseEnter, onCellMouseUp, isCellSelected, onCellValueChange, loading = false, setCellToUpdate } = props;
  const {
    getItemKey,
    bodyHeight,
    rootRef,
  } = useController(props);

  // Use UI column IDs (indices) for selection/ranging to avoid duplicate field ids
  const columnIds = React.useMemo(() => columns.map((_, idx) => idx), [columns]);

  const renderDuplicatedItem = React.useCallback((params: { index: number; data: Array<SpreadsheetTableDefaultDataItem>; style: React.CSSProperties }) => {
    const item = params.data[params.index]!;
    return (
      <Row 
        columnsWidth={columnsWidth}
        key={item.id}
        style={params.style}
        columns={columns}
        columnIds={columnIds}
        dataItem={item}
        rowIndex={params.index}
        spreadsheetId={props.spreadsheetId as any}
        selectionState={selectionState}
        rowSelectionState={rowSelectionState}
        onCellMouseDown={onCellMouseDown}
        onCellMouseEnter={onCellMouseEnter}
        onCellMouseUp={onCellMouseUp}
        isCellSelected={isCellSelected}
        onCellValueChange={onCellValueChange}
        setCellToUpdate={setCellToUpdate}
        onActivateSpreadsheet={props.onActivateSpreadsheet}
      />
    );
  }, [columns, columnsWidth, columnIds, selectionState, rowSelectionState, onCellMouseDown, onCellMouseEnter, onCellMouseUp, isCellSelected, onCellValueChange]);

  const totalWidth = columns.reduce((acc, column) => acc + (columnsWidth[column.id] || 150), 0);

  if (!bodyHeight) {
    return (
      <div ref={rootRef} className={cx('SpreadsheetDetailsSpreadsheetResultTable__body', className)} />
    );
  }

  return (
    <>
      <FixedSizeList
        ref={props.listRef as any}
        className={cx('SpreadsheetDetailsSpreadsheetResultTable__body', className)}
        height={bodyHeight}
        style={{
          paddingBottom: getScrollbarWidth()
        }}
        itemCount={data.length}
        itemSize={20}
        width={totalWidth + getScrollbarWidth()}
        overscanCount={5}
        itemData={data}
        itemKey={getItemKey}
        onItemsRendered={({ visibleStopIndex }) => {
          if (visibleStopIndex >= Math.max(0, data.length - 1 - 3)) {
            onLoadData({ pagination: { start: data.length, size: pageSize } });
          }
        }}
      >
        {renderDuplicatedItem}
      </FixedSizeList>
      
      {/* Loading indicator for pagination */}
      {loading && data.length > 0 && (
        <div className="SpreadsheetDetailsSpreadsheetResultTable__body__loading">
          <div className="SpreadsheetDetailsSpreadsheetResultTable__body__loading__spinner">
            <i className="fa fa-spinner fa-spin"></i>
          </div>
          <div className="SpreadsheetDetailsSpreadsheetResultTable__body__loading__text">
            Loading more data...
          </div>
        </div>
      )}
    </>
  );
};